import {mediumGray} from '@modifi/colors'
import styled from 'styled-components'

export const CIRCLE_SIZE = 24

export const HomeIconWrapper = styled.div`
  height: ${CIRCLE_SIZE}px;
  width: ${CIRCLE_SIZE}px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const DottedCircle = styled.div`
  height: ${CIRCLE_SIZE}px;
  width: ${CIRCLE_SIZE}px;
  border-radius: 50%;
  border: 2px dashed ${mediumGray};
`
